<nb-card>
<nb-card>
  <nb-card-header>
    Invoice requests
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source" (deleteConfirm)="onDeleteConfirm($event)">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>
